import { render, staticRenderFns } from "./DrawerAdmin.vue?vue&type=template&id=24282aaf&scoped=true&"
import script from "./DrawerAdmin.vue?vue&type=script&lang=js&"
export * from "./DrawerAdmin.vue?vue&type=script&lang=js&"
import style0 from "./DrawerAdmin.vue?vue&type=style&index=0&id=24282aaf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24282aaf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VImg,VListItem,VListItemContent,VListItemGroup,VListItemIcon,VNavigationDrawer,VRow,VSpacer})
